import React from 'react';
import { ShieldCheck } from 'lucide-react';

const TrustStrip = () => {
  return (
    <div
      data-testid="trust-strip"
      style={{
        background: 'linear-gradient(135deg, #f8fdf9 0%, #eef7f1 100%)',
        borderTop: '1px solid var(--border-light)',
        borderBottom: '1px solid var(--border-light)',
        padding: '1.25rem 1rem',
        textAlign: 'center'
      }}
    >
      <div
        className="container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.85rem',
          flexWrap: 'wrap',
          maxWidth: '1000px'
        }}
      >
        <ShieldCheck size={22} style={{ color: 'var(--accent-primary)', flexShrink: 0 }} />
        <p style={{
          margin: 0,
          fontSize: '0.95rem',
          color: 'var(--text-primary)',
          lineHeight: 1.5
        }}>
          <strong>Consultations remboursées</strong> par certaines assurances complémentaires —
          <span style={{ color: 'var(--accent-primary)', fontWeight: 600 }}> agréments ASCA &amp; RME</span>.
        </p>
      </div>
    </div>
  );
};

export default TrustStrip;
